import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";
import Panchang from "./Panchang";
const EventModule = React.lazy(() => import("./EventModule"));
// const Panchang = React.lazy(() => import("./Panchang"));
export const EventConfigs = [
    {
        permittedRole: [
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.ACCOMODATION,
            RoutePermittedRole.KITCHEN,
            RoutePermittedRole.SETUP_MANAGER,
        ],
        path: "/event/upcoming",
        element: <EventModule />,
    },
    {
        permittedRole: [
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.ACCOMODATION,
            RoutePermittedRole.KITCHEN,
            RoutePermittedRole.SETUP_MANAGER,
        ],
        path: "/event/panchang",
        element: <Panchang />,
    },
];
